import { useEffect, useState } from "react"

type Props = {
  endDate: Date
  className?: string
}

function getCountdownLabel(endDate: Date) {
  const now = new Date()
  const diff = endDate.getTime() - now.getTime()
  if (diff <= 0) {
    return "00:00"
  } else {
    const minutes = Math.floor((diff / (1000 * 60)) % 60)
    const seconds = Math.floor((diff / 1000) % 60)
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }
}

export function Countdown(props: Props) {
  const [label, setLabel] = useState(() => getCountdownLabel(props.endDate))

  useEffect(() => {
    const interval = setInterval(() => {
      setLabel(getCountdownLabel(props.endDate))
    }, 1000)
    setLabel(getCountdownLabel(props.endDate))

    return () => clearInterval(interval)
  }, [props.endDate])

  return <span className={props.className}>{label}</span>
}
